export default {
  language: '',
  authIntent: 'candidate'
}
